export const zhHK = {
  productLeaflet: '產品小冊子',
  productLeaflets: '產品小冊子',
  policyProvision: '保單條款',
  policyProvisions: '保單條款',
}
